var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("Warehouse.JobNumberInformation"),
            width: "295px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "form-row",
                  staticStyle: { "flex-direction": "row", "max-width": "920px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "margin-right": "20px" },
                      attrs: {
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        ref: "jobsList",
                        staticStyle: { width: "100%", "min-width": "280px" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.options,
                          "column-defs": _vm.column,
                          "row-data": _vm.jobNos
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "spacing" }),
            _c(
              "div",
              { staticClass: "triggers", attrs: { align: "right" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "1" },
                    on: { click: _vm.selectedHandler }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.btn.confirm")) + " ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "2" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.btn.close")) + " ")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }